export class StickynavModule {

    constructor() {

        if ($("#navigation-sticky").length > 0) {
            this.properties();
            this.init();
        }
    }

    properties() {
        this.navigationSelector = '#navigation-sticky .navbar-nav a';
    }

    isInViewport(elem) {

        if (elem === undefined || elem === null) {
            return false;
        }

        let bounding = elem.getBoundingClientRect();
        return (
            bounding.top >= 0 &&
            bounding.left >= 0 &&
            bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
            bounding.right <= (window.innerWidth || document.documentElement.clientWidth)
        );
    }

    scroll() {
        this.selectCurrentSection();
    }

    selectCurrentSection() {
        let _this = this;
        let itemSelected = false;
        let closest = null;
        let closestDist = 0;

        $.each($(this.navigationSelector), function (key, value) {

            let data = $(this).data("component");
            let el = document.querySelector(data);

            if (el !== undefined && data !== undefined && itemSelected !== true) {
                var rect = el.getBoundingClientRect()
                var dist = Math.abs(window.innerHeight / 2 - (rect.y + (rect.height / 2)));
                if (closest === null || dist < closestDist) {
                    closest = this;
                    closestDist = dist;
                }
            }
        });

        if (closest !== null) {
            $(_this.navigationSelector).removeClass("is-selected");
            $(closest).addClass("is-selected");
            itemSelected = true;
            return false;
        }
    }

    registerScrollListener() {

        let _this = this;

        var raf = window.requestAnimationFrame ||
            window.webkitRequestAnimationFrame ||
            window.mozRequestAnimationFrame ||
            window.msRequestAnimationFrame ||
            window.oRequestAnimationFrame;
        var $window = $(window);
        var lastScrollTop = $window.scrollTop();

        if (raf) {
            loop();
        }

        function loop() {
            var scrollTop = $window.scrollTop();
            if (lastScrollTop === scrollTop) {
                raf(loop);
                return;
            } else {
                lastScrollTop = scrollTop;

                // fire scroll function if scrolls vertically
                _this.scroll();
                raf(loop);
            }
        }
    }

    registerClick() {

        $(document).on('click', "#navigation-sticky .nav-link", function () {
            let _this = this;

            setTimeout(() => {
                $("#navigation-sticky .nav-link").removeClass("is-selected");
                $(this).addClass("is-selected")
            }, 200);
        });

        $(document).on('click', "#navigation-sticky-mobile .nav-link", function () {
            let _this = this;

            setTimeout(() => {
                $(".select-wrapper-nav-items").toggle();

                if ($('.select-wrapper-nav-items').css('display') == 'block') {
                    $(".js-select-wrapper-nav--selector").addClass("select-wrapper-nav--selector--open");
                } else {
                    $(".js-select-wrapper-nav--selector").removeClass("select-wrapper-nav--selector--open");
                }

            }, 200);
        });

        $(document).on('click', '.js-select-wrapper-nav--selector', function () {
            $(".select-wrapper-nav-items").toggle();

            if ($('.select-wrapper-nav-items').css('display') == 'block') {
                $(".js-select-wrapper-nav--selector").addClass("select-wrapper-nav--selector--open");
            } else {
                $(".js-select-wrapper-nav--selector").removeClass("select-wrapper-nav--selector--open");
            }
        });

    }

    init() {
        this.registerScrollListener();
        this.registerClick();
    }
}






